// Errors
export const PROBLEM_BASE_URL = 'https://www.jhipster.tech/problem';
export const EMAIL_ALREADY_USED_TYPE = `${PROBLEM_BASE_URL}/email-already-used`;
export const LOGIN_ALREADY_USED_TYPE = `${PROBLEM_BASE_URL}/login-already-used`;
export const GOOGLE_API_KEY = 'AIzaSyAXD4fLOgubSpcSQWob824JJ-BIuzp_v88';
export const MAX_AGE_VIEWING_TIME = 100;
